import { gql, useQuery } from '@apollo/client';
import { CompanyModel } from 'views/AdminView/types';

export const query = gql`
  query ($id: String!) {
    company(id: $id) {
      id
      name
      handle
      description
      image
      tags
      durations
      usesInformalLanguage
    }
  }
`;

const useCompanyQuery = (companyId?: string) => {
  const { data, loading, error, refetch } = useQuery<{ company: CompanyModel }>(query, {
    variables: {
      id: companyId,
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  return { company: data?.company, loading, error, refetch };
};

export default useCompanyQuery;
